import { render, staticRenderFns } from "./AppSideMenu.vue?vue&type=template&id=4fa95634&scoped=true&"
import script from "./AppSideMenu.vue?vue&type=script&lang=ts&"
export * from "./AppSideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AppSideMenu.vue?vue&type=style&index=0&id=4fa95634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa95634",
  null
  
)

export default component.exports